






















import { defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'

export default defineComponent({
  components: { CFormError },
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name } = toRefs(props)
    const perks = ref<string[]>(['', ''])

    const { value, error, changeValue } = useDynamicForm(props)
    perks.value = value.value || ['', '']

    function handleInput(text: string, index: number) {
      perks.value[index] = text
      changeValue(
        name.value,
        perks.value.filter(p => !!p)
      )
    }

    return { handleInput, value, error, perks }
  }
})
